/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 18.07.2016.
 */

import ModalWindow from './modal-window';

export default ModalWindow;


// WEBPACK FOOTER //
// ./src/containers/ModalWindow/index.js